module.exports = __webpack_public_path__ + "8f5c5c056d8a5131adc463c09252a663.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/scarf-green.png
// module id = 1372
// module chunks = 0